/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";
import { Redirect } from 'react-router-dom';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
//import Button from "@material-ui/core/Button";
import './HeaderLinks.css'
// @material-ui/icons
import { Apps, CloudDownload } from "@material-ui/icons";

// core components
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown.jsx";
import Button from "../../components/CustomButtons/Button.jsx";

import headerLinksStyle from "../../assets/jss/material-kit-react/components/headerLinksStyle.jsx";

import {connect} from 'react-redux'
import { logoutUser } from 'redux/actions/authActions';
import { Route, withRouter,Switch} from "react-router-dom";
import IconButton from '@material-ui/core/IconButton';
import Home from '@material-ui/icons/Home';



class HeaderLinks extends React.Component {
  constructor(props) {
    super(props);
  }
  getRoute=()=>{
    return this.props.location.pathname === "/login";
  };
  render() {
    const { ...props } = this.props;
    const { classes } = props;
    const { isAuthenticated } = props.auth;
    const authLinks = (
      <ListItem className={classes.listItem}>
          <Button
            color="transparent"
            className={classes.navLink}
            onClick={() => props.logoutUser()}
          >
            {/* <CloudDownload className={classes.icons} />*/} Вихід
          </Button>
        </ListItem>
    );

    const guestLinks = (
      <ListItem className={classes.listItem}>
          {/* <Button
            component={Link}
            to={'/'}
            color="transparent"
            className={classes.navLink}
            style={{fontSize:"1rem"}}
          >
             Головна
          </Button> */}
          {/* <Button
              color="warning"
              size="lg"
              component={Link} to="/login"
              rel="noopener noreferrer"
              style={{borderRadius:"0px", color:"#1C1C1A"}}
              className="btn100 enterBtn"
            >
              <i className="fas fa-play" />
              Вхід в систему
          </Button > */}
        </ListItem>
    );

    const guest = !this.getRoute() ? guestLinks : null
    return (
      <List className={classes.list}>
        {/* <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            buttonText="Components"
            buttonProps={{
              className: classes.navLink,
              color: "transparent"
            }}
            buttonIcon={Apps}
            dropdownList={[
              <Link to="/" className={classes.dropdownLink}>
                All components
              </Link>,
              <a
                href="https://creativetimofficial.github.io/material-kit-react/#/documentation"
                target="_blank"
                className={classes.dropdownLink}
              >
                Documentation
              </a>
            ]}
          /> 
        </ListItem>*/}
        {isAuthenticated ? authLinks : guest}
        
      {this.getRoute() && <ListItem className={classes.listItem}>
          <Tooltip
            id="instagram-twitter"
            title="На головну"
            placement={window.innerWidth > 959 ? "top-end" : "left-start"}
            classes={{ tooltip: classes.tooltip }}
          >
             <IconButton
            component={Link}
            to={'/'}
            style={{color:"#fff"}}
            className={classes.navLink}
            style={{fontSize:"1rem", color: window.innerWidth > 959 ? "#fff" : '#000'}}
          >
          <Home/>
             {/* Головна */}
          </IconButton>
          </Tooltip>
        </ListItem>}
        {/*  <ListItem className={classes.listItem}>
          <Tooltip
            id="instagram-facebook"
            title="Follow us on facebook"
            placement={window.innerWidth > 959 ? "top" : "left"}
            classes={{ tooltip: classes.tooltip }}
          >
            <Button
              color="transparent"
              href="https://www.facebook.com/CreativeTim"
              target="_blank"
              className={classes.navLink}
            >
              <i className={classes.socialIcons + " fab fa-facebook"} />
            </Button>
          </Tooltip>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Tooltip
            id="instagram-tooltip"
            title="Follow us on instagram"
            placement={window.innerWidth > 959 ? "top" : "left"}
            classes={{ tooltip: classes.tooltip }}
          >
            <Button
              color="transparent"
              href="https://www.instagram.com/CreativeTimOfficial"
              target="_blank"
              className={classes.navLink}
            >
              <i className={classes.socialIcons + " fab fa-instagram"} />
            </Button>
          </Tooltip>
        </ListItem> */}
      </List>
    );
  }
}
const mapStateToProps = state => ({
  auth: state.auth
});

export default withRouter (connect(mapStateToProps, {logoutUser})(withStyles(headerLinksStyle)(HeaderLinks)));



